<template>
    <v-file-input
        prepend-icon=""
        prepend-inner-icon="ic ic-20 ic-file ic-col-grey"
        dense
        outlined
        hide-details="auto"
        clearable
        v-bind="$attrs"
        v-on="$listeners"
    />
</template>

<script>
export default {
    name: 'KpFileInput',
};
</script>

<style lang="scss" scoped></style>
